<template>
  <div class="contact">
    <navbar />

    <div class="home-content">
      <div class="fold-container">
        <div class="container hero-container">
          <div class="first-content">
            <div class="intro-tekst">
              <h1>Je raadt het nooit</h1>
              <p>Maar we verwachtten je al! Neem snel contact met ons op. Samen laten we jouw idee tot leven komen.</p>
              <a v-scroll-to="'#contact'">Alright, let's do this!</a>
            </div>
          </div>

          <div class="case-hightlight-img">
            <div class="intro-animation">
            </div>
          </div>
        </div>
        <div class="contact-bg-color"></div>
    </div>
      <div class="container lets-work" id="contact">
        <div id="lets-work-succes"></div>
        <div class="font-size-custom-max-48"><h2 id="font-calc-contact">Let's work together</h2></div>
        <p>Hulp nodig met het onthullen van je merkidentiteit, of wil je je producten een boost geven? Neem dan contact met ons op via ons formulier, mail ons op <a href="mailto:hello@foldedpaper.nl">hello(at)foldedpaper.nl </a> of bel ons op <a href="tel:0634026022">06-34026022</a>. Wie weet zitten we volgende week al voor onze eerste meeting. Wij hebben er zin in!</p>
      </div>
    </div>  
    <ContactFormGeneral />
    <footerComponent></footerComponent>

  </div>



</template>

<script>
import ContactFormGeneral from '@/components/generalLayout/ContactFormGeneral.vue';
import navbar from '@/components/generalLayout/navbar.vue';
import footerComponent from '@/components/specificLayout/footerComponent.vue';

export default {
  name: 'contact',
  components: {
    ContactFormGeneral,
    navbar,
    footerComponent
  }
}
</script>

<style lang="scss" scoped>



.fold-container .contact-bg-color{
  opacity: 0;
  animation-fill-mode: forwards;
  animation-delay: 0.8s;
}

.contact .fold-container .first-content .intro-tekst{
  animation-delay: 1.2s;
}

.contact{
    a{
      @include transition;
      &:hover{
        @include transition;
        color:$black
      }
    }
}

.contact-bg-color{
  background-image: url(../assets/Folded_Paper_contact_background.jpg);
  background-repeat: no-repeat;
  background-size: cover;
}

.intro-tekst{
  z-index: 1;
  a{
    font-family: $font-stack-copy;
    text-decoration: none;
    font-weight: 900;
  }
}

.lets-work{
  h2,p{
    text-align: center;
  }
  p{
    max-width: 690px;
    margin: 0 auto;
  }
  h2{
    margin-bottom: 16px;
  }
}

.lets-work{
  margin-top: layout-val-8(3);

    h2{
      display: table;
      margin: 0 auto;
      position: relative;
      top:0px;
      margin-bottom: 8px;
    }
    p{
      margin-bottom: 8px;
    }
}

.nda-verklaring{
  a{
    &:hover{
      + .nda-pop-up{
        opacity: 1;
        @include transition;
        top: layout-val-8(-12);
        pointer-events: all;
      }
   }
  }

  .nda-pop-up{
    position: relative;
    top: layout-val-8(-10);
    max-width: 440px;
    background:$black;
    border-radius: 5px;
    box-shadow: 0 10px 20px 0 rgba(0,0,0,0.05), 0 10px 7px 0 rgba(0,0,0,0.02);
    opacity: 0;
    @include transition;
    pointer-events: none;

      p{
        color: $white;
        opacity: 1;
        padding: 8px;
        font-family: $font-stack-copy;
      }

      a{
        color: $white;
      }
      
      a,p{
        @include fluid-type(12px, 14px);
      }
  }

  a{
    text-decoration: underline;
    font-weight: 300;
    font-family: 'futura-pt', sans-serif;
  }

}

@media screen and (max-width: 640px) {
  .fold-container .contact-bg-color{
    max-width: 100% !important;
    border-right: 24px solid $white;
    border-left: 24px solid $white;
    right: 0;
    border-top: 120px solid $white;
    box-sizing: border-box;
  }
}
</style>
